module.exports = __webpack_public_path__ + "media/bootstrap-icons/layout-text-sidebar-reverse-aec9c79b.svg";